import { useState } from 'react';
// @mui
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton, InputAdornment, Stack, Typography, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Iconify from 'src/components/iconify/Iconify';
import MenuPopover from 'src/components/custom-popover';
import { dispatch } from 'src/redux/store';
import { createCardToken } from 'src/redux/slices/card';
import { useSnackbar } from '../../components/snackbar'
import { useAuthContext } from 'src/auth/hooks';
import { useLocales } from 'src/locales';
import { routePrefix } from 'src/utils/methods/StandardMethods';

// ----------------------------------------------------------------------

interface Props extends DialogProps {
    onClose?: any;
    setCardAdded?: any;
}

export default function PaymentNewCardDialog({ onClose, setCardAdded, ...other }: Props) {
    const { translate } = useLocales();

    const { user, updateMyProfile } = useAuthContext();

    const { enqueueSnackbar } = useSnackbar();

    const [formState, setFormState] = useState({
        cardnumber: '',
        cardholder: '',
        expirydate: '',
        cvv: ''
    });

    const [saveAsDefault, setSaveAsDefault] = useState(false);
    // const onChange = (e: any) => {
    //     setFormState({ ...formState, [e.target.name]: e.target.value });
    // }

    const handleSaveAsDefault = (e: any) => {
        setSaveAsDefault(e.target.checked);
    }

    const onChange = (event: any, type?: string) => {
        if (type === 'expiry' && event.target.value.length === 3 && event.target.value[2] !== '/') {
            setFormState({ ...formState, [event.target.name]: event.target.value.substring(0, 2) + '/' + event.target.value.substring(2, event.target.value.length) });
        } else {
            setFormState({ ...formState, [event.target.name]: event.target.value });
        }
    };

    const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

    const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
        setOpenPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setOpenPopover(null);
    };

    const handleSubmit = () => {
        const orgCode = routePrefix(user);

        dispatch(createCardToken(formState, orgCode))
            .then((res : any) => { setCardAdded(true); res.newCard.cardId ? enqueueSnackbar(translate('Card Information Submited')) : enqueueSnackbar(translate('Error in saving card details'), { variant: 'error' }); onClose(); })
            .catch((err : any) => console.log(err));

        updateMyProfile(user?.id)
    }
    return (
        <>
            <Dialog maxWidth="md" onClose={onClose} {...other}>
                <DialogTitle> {translate("New Card")} </DialogTitle>

                <DialogContent sx={{ overflow: 'unset' }}>
                    <Stack spacing={3}>
                        <TextField fullWidth name='cardnumber' label={translate("Card Number")} placeholder='XXXX XXXX XXXX XXXX' inputProps={{ maxLength: 16 }} InputLabelProps={{ shrink: true }} onChange={(e: any) => onChange(e)} />

                        <TextField fullWidth name='cardholder' label={translate("Card Holder")} placeholder={translate('JOHN DOE')} InputLabelProps={{ shrink: true }} onChange={(e: any) => onChange(e)} />
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TextField name='expirydate' label={translate("Expiration Date")} placeholder='MM/YY' InputLabelProps={{ shrink: true }} inputProps={{ maxLength: 5 }} onChange={(e: any) => onChange(e, 'expiry')} />

                            <TextField
                                name='cvv'
                                onChange={(e: any) => onChange(e)}
                                label={translate("CVV/CVC")}
                                placeholder='***'
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 4 }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton size="small" edge="end" onClick={handleOpenPopover}>
                                                <Iconify icon="material-symbols:info-outline" />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Stack>
                        <Stack>
                            <Stack direction='row' alignItems='center'><Iconify color='grey' icon='iconoir:lock' /><Typography color='grey' variant='caption'> {translate("Your transaction is secured with SSL encryption")}</Typography></Stack>
                            <Stack direction='row' alignItems='center'> <FormControlLabel key='checkbox' control={<Checkbox key='saveAsDefault' value={saveAsDefault} onChange={(e) => handleSaveAsDefault(e)} />} label={translate('Save as default')} /></Stack>
                        </Stack>
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button color="inherit" variant="outlined" onClick={onClose}>
                        {translate("Cancel")}
                    </Button>

                    <Button type='button' variant="contained" onClick={() => handleSubmit()}>
                        {translate("Add")}
                    </Button>
                </DialogActions>
            </Dialog>

            <MenuPopover
                open={openPopover}
                onClose={handleClosePopover}
                arrow="bottom-center"
                sx={{ maxWidth: 200, typography: 'body2', textAlign: 'center' }}
            >
                {translate("Three-digit number on the back of your card")}
            </MenuPopover>
        </>
    );
}
